import { ErrorBuilder, SchemaErrors } from 'src/utils/validation';
import { TFunction } from 'react-i18next';
import { CbamElectricitySchema, ElectricityFactorSource } from 'src/Cbam/types';

export type FormErrors = SchemaErrors<CbamElectricitySchema>;

export const requiredFields: (keyof CbamElectricitySchema)[] = [
  'electricity_consumption',
  'source',
  'factor_source',
];

export const validateForm = (
  data: CbamElectricitySchema,
  t: TFunction
): FormErrors => {
  const builder = new ErrorBuilder(data);
  return builder
    .checkTruthy(requiredFields, t('validation.required'))
    .checkRule(
      ['factor_source_details'],
      (field, schema) => {
        if (schema.factor_source === ElectricityFactorSource.OTHER) {
          return !!field;
        }
        return true;
      },
      t('validation.required')
    )
    .checkRule(
      ['emission_factor_other'],
      (field, schema) => {
        if (schema.factor_source === ElectricityFactorSource.OTHER) {
          return !!field;
        }
        return true;
      },
      t('validation.required')
    )
    .build();
};
